import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { map, Observable, Subscription } from 'rxjs';

import { ModeNamesEnum } from 'app/modules/browse/models/browse-mode';
import { CarouselItems } from 'app/modules/browse/models/carousel-items.enum';
import { Landscape } from 'app/modules/browse/models/landscape';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';
import { WorldRegion } from 'app/modules/browse/models/world-region';
import { PlaylistStore } from 'app/modules/browse/store/playlist/playlist.store';
import { RegionAndLandscapeStore } from 'app/modules/browse/store/region-and-landscape/region-and-landscape.store';
import { VideoStore } from 'app/modules/browse/store/video/video.store';
import { ScrollingService } from 'app/services/scrolling.service';
import { BrowseTypesEnum } from 'app/modules/browse/models/browse-types.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ListingComponent } from '../../../components/listing/listing.component';
import { BackButtonComponent } from '../../../components/back-button/back-button.component';
import { DoubleCarouselComponent } from '../../../components/carousels/double-carousel/double-carousel.component';
import { BrowseCarouselComponent } from '../../../components/carousels/browse-carousel/browse-carousel.component';
import { AsyncPipe } from '@angular/common';
import { VideoSection } from '@kinomap-dev/ng-ui-lib';
import { ActivatedRoute, ParamMap, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-catalog-video',
  templateUrl: './catalog-video.component.html',
  styleUrls: ['./catalog-video.component.scss'],
  standalone: true,
  imports: [
    BrowseCarouselComponent,
    DoubleCarouselComponent,
    BackButtonComponent,
    ListingComponent,
    AsyncPipe,
    TranslateModule,
    RouterLink,
  ],
})
export class CatalogVideoComponent implements OnInit, OnDestroy {
  @Output() activateOrDeactivateHomeMode: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  ModeNames: typeof ModeNamesEnum = ModeNamesEnum;
  ContentTypes: typeof BrowseTypesEnum = BrowseTypesEnum;
  CarouselItem: typeof CarouselItems = CarouselItems;
  displayMode: 'home' | 'video' | 'playlist' = 'home';
  homeVideos$: Observable<VideoSection[]>;
  recommendedVideos$: Observable<VideoSection[]>;
  homePlaylists$: Observable<Playlist[]>;
  top10Videos$: Observable<VideoSection[]>;
  landscapes$: Observable<Landscape[]>;
  regions$: Observable<WorldRegion[]>;

  subscription: Subscription;

  constructor(
    private scrollingService: ScrollingService,
    private videoStore: VideoStore,
    private playlistStore: PlaylistStore,
    private regionsAndLandscapeStore: RegionAndLandscapeStore,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.homeVideos$ = this.videoStore.homeVideos$;
    this.recommendedVideos$ = this.videoStore.recommendedVideos$;
    this.homePlaylists$ = this.playlistStore.homePlaylists$;
    this.top10Videos$ = this.videoStore.top10Videos$;
    this.landscapes$ = this.regionsAndLandscapeStore.landscapes$;
    this.regions$ = this.regionsAndLandscapeStore.regions$;
    this.activateOrDeactivateHomeMode.next(true);

    this.subscription = this.route.queryParamMap.subscribe(
      (paramMap: ParamMap) => {
        if (paramMap.get('location')) {
          const param: string = paramMap.get('location');
          switch (param) {
            case BrowseTypesEnum.Video:
              this.onSwitchDisplayMode('video');
              break;

            case BrowseTypesEnum.Playlist:
              this.onSwitchDisplayMode('playlist');
              break;

            default:
              this.onSwitchDisplayMode('home');
              break;
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.activateOrDeactivateHomeMode.next(false);
    this.subscription?.unsubscribe();
  }

  onSwitchDisplayMode(newDisplayMode: 'home' | 'video' | 'playlist'): void {
    this.router.navigate([], {
      queryParams: { location: newDisplayMode },
      queryParamsHandling: 'merge',
    });

    this.displayMode = newDisplayMode;
    this.scrollingService.detectChangesAndScrollSmoothlyTo('scrollLandmark');
    this.activateOrDeactivateHomeMode.next(this.displayMode === 'home');
  }

  doesListExist$(list$: Observable<any[]>): Observable<boolean> {
    return list$.pipe(
      map((list) => {
        return !!list && list.length > 0;
      })
    );
  }
}
